import ContactUs from "./components/contact-us";
// import HomeImage from "../assets/media/svg/admin-platform-5.svg";
import HomeImage from "../assets/media/Hero (2).png";
import BackGroundImage from "../assets/media/svg/Hero.svg";
import BackGroundImage1 from "../assets/media/svg/bg-download.svg";
import AboutOne from "../assets/media/svg/about1.svg";
import AboutTwo from "../assets/media/svg/about2.svg";
import TestimonialIcon from "../assets/media/svg/testimonial.svg";
import PlayStoreImage from "../assets/media/svg/play-store.svg";
import AppStoreImage from "../assets/media/svg/app-store.svg";
import MobileImage from "../assets/media/svg/mobile.svg";
import FeatureOne from "../assets/media/svg/daily-log.svg";
import FeatureTwo from "../assets/media/svg/training.svg";
import FeatureThree from "../assets/media/chat.svg";
import FeatureFour from "../assets/media/svg/life-stroy.svg";
import FeatureFive from "../assets/media/svg/knoelwdge-bank.svg";
// import FeatureSix from "../assets/media/svg/payment.svg";
import FeatureSix from "../assets/media/svg/showcase.svg";
import FeatureSeven from "../assets/media/svg/admin-platform-4.svg";
import VerifiedIcon from "../assets/media/svg/verified.svg";
import ArrowIcon from "../assets/media/svg/arrow.svg";
import {Accordion, Card, Col, Row} from "react-bootstrap";
import {useState} from "react";
import axios from "axios";
import {BASE_URL} from "../utils/constants";
import Header from "../components/header";
import LogImage from "../assets/media/FosterLogs.png";
import TrainingImage from "../assets/media/Training.png";
import ChatImage from "../assets/media/Chat.png";
import DocumentImage from "../assets/media/document.png";
import LifeStoryImage from "../assets/media/LifeStory.png";
import WebDetailImage from "../assets/media/WebDetail.png";

const Home = () => {
    const [faqList, setFaqList] = useState<any>([
        {
            question: "Is my data secure?",
            answer: "Yes, your data is securely stored and encrypted to protect your privacy. The app adheres to industry-standard security practices to ensure your information remains confidential. We utilize EU-based servers and data centers that comply with GDPR standards.",
        },
        {
            question: "Can I control who can access certain tools and information?",
            answer: "You have full control of who can use the app, what information they can see and which tools they can use.",
        },
        {
            question: "Do I have to use all of the features?",
            answer: "No, you can choose to use which features are most valuable and relevant for your agency.",
        },
        {
            question: "Pricing",
            answer: "We have a range of subscription options, we’d be happy to discuss pricing for your specific agency.",
        },
    ]);
    const [loading, setLoading] = useState(false);

    // useEffect(() => {
    //   fetchFaq();
    // }, []);

    const scrollToSection = (event: any, sectionId: string) => {
        event.preventDefault();

        const section = document.getElementById(sectionId);
        const navbarHeight = document.querySelector("nav")?.offsetHeight;

        if (section) {
            const sectionTop = section.getBoundingClientRect().top + window.scrollY;
            window.scrollTo({
                top: navbarHeight && sectionTop - navbarHeight,
                behavior: "smooth",
            });
        }
    };

    const fetchFaq = async () => {
        let params = {
            sortKey: "_createdAt",
            sortOrder: -1,
        };
        setLoading(true);
        try {
            const response = await axios.get(`${BASE_URL}/admin/faqList`, {
                params: params,
                headers: {
                    "ngrok-skip-browser-warning": "69420",
                },
            });
            if (response && response.data) {
                console.log("faqList", faqList);
            }
        } catch (error) {
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Header showButton={true} />
            <div className="content-wrapper">
                <section
                    id="home"
                    className="wrapper"
                    style={{
                        backgroundImage: `url(${BackGroundImage})`,
                        backgroundSize: "cover",
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "center",
                        zIndex: 0,
                    }}
                >
                    <div className="container-fluid pt-17 pb-12">
                        <div className="row gy-4  align-items-center">
                            <div className="col-lg-7">
                                <div className="row justify-content-lg-center justify-content-xl-end">
                                    <div className="col-md-11 text-center text-lg-start">
                                        <h1 className="fs-48 fw-700  text-white">
                                            Empowering foster carers
                                            <br />
                                            with a smart, streamlined
                                            <br />
                                            communication tool
                                        </h1>
                                        <p className="lead fs-20 fw-400 mb-8 text-white">
                                            Modernising social work communication. Supercharging routine tasks. A GDPR
                                            compliant app for foster carers and agencies.
                                        </p>
                                        <a
                                            className="btn btn-dark fs-16 fw-600"
                                            onClick={(e) => scrollToSection(e, "contact-us")}
                                        >
                                            Schedule a Demo
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-5 text-center text-lg-end right-side-img">
                                <img
                                    // img-fluid
                                    className="img-fluid"
                                    src={HomeImage}
                                    alt="Healthcare learning"
                                    height={1407}
                                    width={2361}
                                    // style={{ marginRight: '-160px' }}
                                />
                            </div>
                        </div>
                    </div>
                </section>

                <section id="features" className="py-md-8 py-6" style={{backgroundColor: "#F9F9FB"}}>
                    <div className="container">
                        <div className="row mb-4">
                            <div className="col-12 text-center">
                                <div className="fs-48 fw-600">Save time, increase efficiency</div>
                                <div className="fs-20 fw-400 text-center mt-2 text-muted">
                                    The easy to use, easy to implement iOS/Android app for foster carers
                                </div>
                            </div>
                        </div>
                        <Card className="mb-4 rounded-4">
                            <Card.Body className="px-md-10">
                                <div className="row">
                                    <div className="col-lg-7">
                                        <div className="h-100 d-flex flex-wrap flex-column justify-content-center">
                                            <div className="fs-40 fw-600 text-black">
                                                Create and submit logs directly from the app.
                                            </div>
                                            <div className="fs-18 fw-400 mt-3 d-flex align-items-start gap-2">
                                                <img
                                                    src={VerifiedIcon}
                                                    alt="verified"
                                                    className="flex-shrink-0 d-block mt-1"
                                                    width={22}
                                                    height={22}
                                                />
                                                <div>
                                                   Foster carers can submit logs via voice entry or text effortlessly. 
                                                </div>
                                            </div>
                                            <div className="fs-18 fw-400  mt-2 d-flex align-items-start gap-2">
                                                <img
                                                    src={VerifiedIcon}
                                                    alt="verified"
                                                    className="flex-shrink-0 d-block mt-1"
                                                    width={22}
                                                    height={22}
                                                />
                                                <div>Save a log as draft and submit when ready. </div>
                                            </div>
                                            <div className="fs-18 fw-400  mt-2 d-flex align-items-start gap-2">
                                                <img
                                                    src={VerifiedIcon}
                                                    alt="verified"
                                                    className="flex-shrink-0 d-block mt-1"
                                                    width={22}
                                                    height={22}
                                                />
                                                <div>
                                                    Agencies can tailor the questions foster carers need to answer.
                                                </div>
                                            </div>
                                            <div className="fs-18 fw-400  mt-2 d-flex align-items-start gap-2">
                                                <img
                                                    src={VerifiedIcon}
                                                    alt="verified"
                                                    className="flex-shrink-0 d-block mt-1"
                                                    width={22}
                                                    height={22}
                                                />
                                                <div>Social workers can monitor and review daily logs.</div>
                                            </div>
                                            <div
                                                className="fs-18 fw-600 my-3 d-inline-flex align-items-center gap-2"
                                                style={{color: "#007B8B"}}
                                            >
                                                <span
                                                    className="cursor-pointer"
                                                    onClick={(e) => scrollToSection(e, "contact-us")}
                                                >
                                                    Book a demo
                                                </span>
                                                <img
                                                    src={ArrowIcon}
                                                    className="cursor-pointer flex-shrink-0 d-inline-block"
                                                    alt="Arrow"
                                                    width={6}
                                                    height={12}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-5">
                                        <div className="d-flex justify-content-center">
                                            <img src={LogImage} className="img-fluid" alt="Feature One" />
                                        </div>
                                    </div>
                                </div>
                            </Card.Body>
                        </Card>
                        <Card className="mb-4 rounded-4">
                            <Card.Body className="px-md-10">
                                <div className="row">
                                    <div className="col-lg-5">
                                        <div className="d-flex justify-content-center">
                                            <img src={DocumentImage} className="img-fluid" alt="Documents" />
                                        </div>
                                    </div>
                                    <div className="col-lg-7">
                                        <div className="h-100 d-flex flex-wrap flex-column justify-content-center">
                                            <div className="fs-40 fw-600 text-black">Documents Made Simple</div>
                                            <div className="fs-18 fw-400 mt-3 d-flex align-items-start gap-2">
                                                <img
                                                    src={VerifiedIcon}
                                                    alt="verified"
                                                    className="flex-shrink-0 d-block mt-1"
                                                    width={22}
                                                    height={22}
                                                />
                                                <div>
                                                    Send documents directly to carers, who can review and securely e-sign
                                                    in the app.
                                                </div>
                                            </div>
                                            <div className="fs-18 fw-400 mt-2 d-flex align-items-start gap-2">
                                                <img
                                                    src={VerifiedIcon}
                                                    alt="verified"
                                                    className="flex-shrink-0 d-block mt-1"
                                                    width={22}
                                                    height={22}
                                                />
                                                <div>
                                                    Carers can upload and share documents securely, keeping everything
                                                    organised.
                                                </div>
                                            </div>
                                            <div className="fs-18 fw-400 mt-2 d-flex align-items-start gap-2">
                                                <img
                                                    src={VerifiedIcon}
                                                    alt="verified"
                                                    className="flex-shrink-0 d-block mt-1"
                                                    width={22}
                                                    height={22}
                                                />
                                                <div>Agencies can track completion and follow up as needed.</div>
                                            </div>
                                            <div
                                                className="fs-18 fw-600 mt-8 d-inline-flex align-items-center gap-2"
                                                style={{color: "#007B8B"}}
                                            >
                                                <span
                                                    className="cursor-pointer"
                                                    onClick={(e) => scrollToSection(e, "contact-us")}
                                                >
                                                    Book a demo
                                                </span>
                                                <img
                                                    src={ArrowIcon}
                                                    className="cursor-pointer flex-shrink-0 d-inline-block"
                                                    alt="Arrow"
                                                    width={6}
                                                    height={12}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Card.Body>
                        </Card>
                        <Card className="mb-4 rounded-4">
                            <Card.Body className="px-md-10">
                                <div className="row">
                                    <div className="col-lg-5 order-lg-2">
                                        <div className="d-flex justify-content-center">
                                            <img src={TrainingImage} className="img-fluid" alt="Training" />
                                        </div>
                                    </div>
                                    <div className="col-lg-7 align-items-center order-lg-1">
                                        <div className="h-100 d-flex flex-wrap flex-column justify-content-center">
                                            <div className="fs-40 fw-600 text-black">Manage training and meetings</div>
                                            <div className="fs-18 fw-400 mt-7 d-flex align-items-start gap-2">
                                                <img
                                                    src={VerifiedIcon}
                                                    alt="verified"
                                                    className="flex-shrink-0 d-block mt-1"
                                                    width={22}
                                                    height={22}
                                                />
                                                <div>Foster carers can register for upcoming training in the app.</div>
                                            </div>
                                            <div className="fs-18 fw-400  mt-2 d-flex align-items-start gap-2">
                                                <img
                                                    src={VerifiedIcon}
                                                    alt="verified"
                                                    className="flex-shrink-0 d-block mt-1"
                                                    width={22}
                                                    height={22}
                                                />
                                                <div>Agencies can track registration and attendance.</div>
                                            </div>
                                            <div className="fs-18 fw-400 mt-2 d-flex align-items-start gap-2">
                                                <img
                                                    src={VerifiedIcon}
                                                    alt="verified"
                                                    className="flex-shrink-0 d-block mt-1"
                                                    width={22}
                                                    height={22}
                                                />
                                                <div>
                                                    An integrated calendar tool so foster carers can manage their
                                                    appointments.
                                                </div>
                                            </div>
                                            <div
                                                className="fs-18 fw-600 mt-8 d-inline-flex align-items-center gap-2"
                                                style={{color: "#007B8B"}}
                                            >
                                                <span
                                                    className="cursor-pointer"
                                                    onClick={(e) => scrollToSection(e, "contact-us")}
                                                >
                                                    Book a demo
                                                </span>
                                                <img
                                                    src={ArrowIcon}
                                                    className="cursor-pointer flex-shrink-0 d-inline-block"
                                                    alt="Arrow"
                                                    width={6}
                                                    height={12}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Card.Body>
                        </Card>
                        <Card className="mb-4 rounded-4">
                            <Card.Body className="px-md-10">
                                <div className="row">
                                    <div className="col-lg-5">
                                        <div className="d-flex justify-content-center">
                                            <img src={ChatImage} className="img-fluid" alt="Secure messaging" />
                                        </div>
                                    </div>
                                    <div className="col-lg-7">
                                        <div className="h-100 d-flex flex-wrap flex-column justify-content-center">
                                            <div className="fs-40 fw-600 text-black">Communicate securely</div>
                                            <div className="fs-18 fw-400 mt-3 d-flex align-items-start gap-2">
                                                <img
                                                    src={VerifiedIcon}
                                                    alt="verified"
                                                    className="flex-shrink-0 d-block mt-1"
                                                    width={22}
                                                    height={22}
                                                />
                                                <div>
                                                    Fully encrypted messaging platform where agency staff, social
                                                    workers and foster carers can text, call and leave voice notes
                                                    securely.
                                                </div>
                                            </div>
                                            <div className="fs-18 fw-400  mt-2 d-flex align-items-start gap-2">
                                                <img
                                                    src={VerifiedIcon}
                                                    alt="verified"
                                                    className="flex-shrink-0 d-block mt-1"
                                                    width={22}
                                                    height={22}
                                                />
                                                <div>
                                                    Eliminate the risk of sending sensitive and confidential information
                                                    to a random group chat!
                                                </div>
                                            </div>
                                            <div
                                                className="fs-18 fw-600 mt-10 mb-1 mb-md-0 d-inline-flex align-items-center gap-2"
                                                style={{color: "#007B8B"}}
                                            >
                                                <span
                                                    className="cursor-pointer"
                                                    onClick={(e) => scrollToSection(e, "contact-us")}
                                                >
                                                    Book a demo
                                                </span>
                                                <img
                                                    src={ArrowIcon}
                                                    className="cursor-pointer flex-shrink-0 d-inline-block"
                                                    alt="Arrow"
                                                    width={6}
                                                    height={12}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Card.Body>
                        </Card>
                        <Row className="mb-4 align-items-stretch gy-4">
                            <Col lg={6}>
                                <div className="align-self-stretch">
                                    <Card className="w-100 rounded-4 overflow-hidden border-0">
                                        <Card.Img
                                            variant="top"
                                            src={LifeStoryImage}
                                            className="w-100 d-block rounded-0"
                                        />
                                        <Card.Body className="p-md-4">
                                            <Card.Title className="fs-26 fw-600">
                                                Securely capture and store photos to document a child's journey
                                            </Card.Title>
                                            <Card.Text className="fs-16 fw-400 text-65737D">
                                                Foster carers have a dedicated place to document and celebrate each
                                                child’s milestones, memories, and experiences. If a child moves to
                                                another placement, so does their life story.
                                            </Card.Text>
                                        </Card.Body>
                                    </Card>
                                </div>
                            </Col>
                            <Col lg={6}>
                                <Col xs={12}>
                                    <Card className="w-100 rounded-4 overflow-hidden border-0">
                                        <Card.Img
                                            variant="top"
                                            src={FeatureFive}
                                            className="w-100 d-block rounded-0"
                                        />
                                        <Card.Body className="p-md-4">
                                            <Card.Title className="fs-26 fw-600">Knowledge base</Card.Title>
                                            <Card.Text className="fs-16 fw-400 lh-base text-65737D">
                                                A dedicated area to access essential documents like the Foster Care
                                                Handbook and other key information quickly. Agencies can fully customize
                                                their knowledge base and include images and videos to empower foster
                                                carers to get the information when and where they need it.
                                            </Card.Text>
                                        </Card.Body>
                                    </Card>
                                </Col>
                                <Col xs={12}>
                                    <Card className="w-100 rounded-4 mt-4 overflow-hidden border-0">
                                        <Card.Img
                                            variant="top"
                                            src={FeatureSix}
                                            className="w-100 d-block rounded-0"
                                        />
                                        <Card.Body className="p-md-4">
                                            <Card.Title className="fs-26 fw-600">Payments and expenses</Card.Title>
                                            <Card.Text className="fs-16 fw-400 lh-base text-65737D">
                                                Upload receipts and submit expenses from the app. Social workers and
                                                agencies can review and then approve or reject. Agencies can track
                                                expense submissions in the admin platform.
                                            </Card.Text>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Col>
                        </Row>
                        <Row className="gy-4 align-items-stretch">
                            <Col lg={12}>
                                <Card className="w-100 rounded-4 overflow-hidden border-0">
                                    <Card.Img
                                        variant="top"
                                        src={WebDetailImage}
                                        className="w-100 d-block rounded-0"
                                    />
                                    <Card.Body className="p-md-4">
                                        <Card.Title className="fs-26 fw-600">
                                            Comprehensive admin platform for foster agencies
                                        </Card.Title>
                                        <Card.Text className="fs-16 fw-400 text-65737D mt-3">
                                            <Row>
                                                <Col lg={6}>
                                                    While the mobile app gives foster carers and social workers
                                                    intuitive tools, our robust admin interface provides foster agencies
                                                    advanced features for case management, reporting, and communication.
                                                </Col>
                                                <Col lg={6}>
                                                    Fostering Connect has been designed with security and flexibility at
                                                    the forefront - you have full control of which tools and information
                                                    users can access with a comprehensive permissions structure.{" "}
                                                </Col>
                                            </Row>
                                        </Card.Text>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </div>
                </section>

                <section id="about-us" className="py-md-4 py-6">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-10 text-center mt-10">
                                <p className="fs-24 fw-600 bg-007B8B">About Us</p>
                                <h2 className="fs-40 fw-600 mb-4">Revolutionising foster care with smarter tools</h2>
                                <p className="fs-20 fw-400 lh-base text-65737D">
                                    At Fostering Connect we want to Transform the way foster carers engage with agencies
                                    and social workers by providing a comprehensive and easy-to-use platform to
                                    accompany them on their fostering journey.
                                </p>
                                <p className="fs-20 fw-400 lh-base text-65737D mb-4">
                                    We’re committed to help drive efficiency for our customers as well as improving
                                    security and GDPR compliance.
                                </p>
                                <p className="fs-20 fw-400 lh-base text-65737D mb-4">
                                    Ultimately, we want to help carers focus on what truly matters – providing a safe
                                    and nurturing environment for the children in their care.
                                </p>
                                <div className="d-flex flex-wrap justify-content-center gap-5">
                                    <img src={AboutOne} alt="one" className="img-fluid" />
                                    <img className="img-fluid" src={AboutTwo} alt="one" />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section id="founders" className="py-md-4 py-6">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12 mt-10">
                                <div className="text-center">
                                    <p className="fs-24 fw-600 bg-007B8B">Meet Our Founders</p>
                                    <h1 className="fs-40 fw-600">Innovating social work with expertise and passion</h1>
                                </div>
                            </div>
                        </div>
                        <Row className="mt-7">
                            <Col lg={6} className="d-flex align-items-stretch">
                                <Card className="rounded-4 bg-F4F9FF">
                                    <Card.Body className="d-flex flex-column  justify-content-between">
                                        <Card.Text className="fs-20 fw-400 lh-sm text-black">
                                        Throughout my career as a qualified social worker I have wanted to modernise how we communicate. Our app is an easy to use tool created for our foster carers, social workers and business support.<br />
                                            <br />
                                            The app will save time and ensure compliance, which will ultimately allow all of us to play the role we care about most; keeping our children safe and ensuring they meet their full potential. 
                                        </Card.Text>
                                        <div className="d-flex flex-wrap justify-content-between align-items-center">
                                            <div className="d-flex">
                                                <Card.Title className="me-2">- Clare Gleeson</Card.Title>
                                                <Card.Subtitle className="align-self-center text-65737D fw-400">
                                                    Co Founder
                                                </Card.Subtitle>
                                            </div>
                                            <div className="text-65737D">
                                                <img src={TestimonialIcon} alt="Testimonial" />
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col lg={6} className="d-flex align-items-stretch mt-2 mt-lg-0">
                                <Card className="rounded-4 bg-F2FFF9">
                                    <Card.Body className="d-flex flex-column justify-content-between">
                                        <Card.Text className="fs-20 fw-400 lh-sm text-black">
                                            I’ve spent most of my career in Higher Education brokering relationships
                                            between industry and education, and helping students reach their true
                                            potential. <br />
                                            <br />
                                            Now working in the tech sector, I am energised by using technology to
                                            improve the fostering journey for both foster carers and agencies.
                                        </Card.Text>
                                        <div className="d-flex flex-wrap justify-content-between align-items-center">
                                            <div className="d-flex">
                                                <Card.Title className="me-2">- Fergus Gleeson</Card.Title>
                                                <Card.Subtitle className="align-self-center text-65737D fw-400">
                                                    Co Founder
                                                </Card.Subtitle>
                                            </div>
                                            <div className="text-65737D">
                                                <img src={TestimonialIcon} alt="Testimonial" />
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </div>
                </section>

                <section id="download-app" className="py-md-8 py-6">
                    <div className="container mt-10">
                        <Card
                            className="rounded-4"
                            style={{
                                position: "relative",
                                backgroundImage: `url(${BackGroundImage})`,
                                backgroundSize: "cover",
                                backgroundRepeat: "no-repeat",
                                backgroundPosition: "center",
                                zIndex: 0,
                            }}
                        >
                            <Card.Body className="py-0">
                                <Row className="mx-2 mt-2">
                                    <Col lg={6}>
                                        <div className="h-100 d-flex flex-wrap flex-column justify-content-center">
                                            <div className="fs-38 fw-700 text-white">
                                                Start your journey – Download the app now
                                            </div>
                                            <div className="fs-18 fw-400 mt-2 text-white">
                                                Download the app today and experience seamless foster care management.
                                            </div>

                                            <div className="mt-2">
                                                <a target="_blank" href="https://play.google.com/store/apps/details?id=com.fostering.connect">
                                                    <img
                                                        className="img-fluid"
                                                        src={PlayStoreImage}
                                                        alt="play-sore"
                                                        style={{cursor: "pointer"}}
                                                    />
                                                </a>
                                                <a target="_blank" href="https://apps.apple.com/us/app/fostering-connect/id6745176805">
                                                    <img
                                                        className="img-fluid"
                                                        src={AppStoreImage}
                                                        alt="app-sore"
                                                        style={{cursor: "pointer"}}
                                                    />
                                                </a>
                                            </div>
                                            {/* <span className="mt-1 fs-16 text-white fw-bold">Coming soon...</span> */}
                                        </div>
                                    </Col>
                                    <Col lg={6} className="p-0">
                                        <div className="d-flex justify-content-center">
                                            <img src={MobileImage} className="img-fluid" />
                                        </div>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </div>
                </section>

                <section id="faqs" className="mt-10 bg-f9f9fB">
                    <div className="container">
                        <Row>
                            <Col lg={6} className="mt-10">
                                <div className="fs-40 fw-600">Frequently Asked Questions</div>
                                <div className="fs-20 fw-400 mt-2 lh-base text-65737D">
                                    Clear answers to the most common questions about foster care and how our app can
                                    support you.
                                </div>
                            </Col>
                            <Col lg={6}>
                                <Accordion
                                    className="accordion-wrapper mb-10 mt-10"
                                    //   defaultActiveKey="0"
                                >
                                    {faqList &&
                                        faqList.map((item: any, index: number) => {
                                            return (
                                                <>
                                                    <Accordion.Item
                                                        className="custom-accordion-item bg-transparent px-0 mb-3 rounded-0"
                                                        eventKey={`${index}`}
                                                    >
                                                        <Accordion.Header className="card-header fs-20 fw-600 p-0">
                                                            {item.question || ""}
                                                        </Accordion.Header>
                                                        <Accordion.Body className="fs-16 fw-400 text-65737D px-0">
                                                            {item.answer || ""}
                                                        </Accordion.Body>
                                                    </Accordion.Item>
                                                </>
                                            );
                                        })}
                                </Accordion>
                            </Col>
                        </Row>
                    </div>
                </section>
                <section id="contact-us" className="wrapper bg-f9f9fB">
                    <ContactUs />
                </section>
            </div>
        </>
    );
};
export default Home;
